module.exports = __webpack_public_path__ + "img/food3.a4ec8589.jpg";